<template>
    <div class="bidder-child-page">
        <div class="page-header">
            <div class="page-header-content">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title">中标公告</h2>
            </div>
            <div class="header-action">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>

        <!-- 数据表格 -->
        <div class="content-container">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center" />
                <el-table-column prop="winBulletinCode" label="公告编码" show-overflow-tooltip />
                <el-table-column prop="winBulletinName" label="公告名称" show-overflow-tooltip />
                <el-table-column prop="bidSectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column prop="winningBidderName" label="中标单位名称" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.row.winBidderList && scope.row.winBidderList.length > 0">
                            <div v-for="(bidder, index) in scope.row.winBidderList" :key="index">
                                {{ bidder.winBidderName }}
                            </div>
                        </div>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="winningBidPrice" label="中标价格(元)" width="150" align="right">
                    <template slot-scope="scope">
                        <div v-if="scope.row.winBidderList && scope.row.winBidderList.length > 0">
                            <div v-for="(bidder, index) in scope.row.winBidderList" :key="index">
                                <span class="price-text">{{ bidder.bidAmount }}</span>
                            </div>
                        </div>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusType(scope.row.status)" size="small">
                            {{ getStatusText(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleViewDetails(scope.row)" class="action-btn">
                            查看
                        </el-button>

                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>

        <!-- 公告详情弹窗 -->
        <el-dialog title="查看中标公告" :visible.sync="detailDialogVisible" width="80%"
            :before-close="handleCloseDetailDialog" :append-to-body="true" class="check-notice-detail-dialog">
            <div class="detail-view" v-loading="detailLoading">
                <div class="detail-item">
                    <label>标段名称</label>
                    <span>{{ detailRow.bidSectionName || '-' }}</span>
                </div>
                <div class="detail-item detail-item--block">
                    <label>公告内容</label>
                    <div class="detail-content" v-if="detailRow.winBulletinContent" v-html="detailRow.winBulletinContent"></div>
                    <div class="detail-empty" v-else>暂无公告内容</div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCloseDetailDialog">关闭</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { loadProjectDetail } from '@/utils/bid/projectInfo'
import { winBulletinList, winBulletinDelete, winBulletinDetail } from '@/api/modules/winBulletin'
import { sanitizeHtml } from '@/utils/sanitizeHtml'


export default {
    name: 'WinningBidAnnouncement',
    data() {
        return {
            loading: false,
            projectTitle: '',
            projectCode: this.$route.query.projectCode,
            tableData: [],
            detailDialogVisible: false,
            detailLoading: false,
            detailRow: {
                bidSectionName: '',
                winBulletinContent: ''
            },
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 1
            }
        }
    },
    mounted() {
        this.ininPage()

    },
    methods: {
        ininPage() {
            this.pagination.currentPage = 1
            this.getProjectInfo()
            this.getBulletinList()
        },
        async getBulletinList() {
            this.loading = true
            try {
                const response = await winBulletinList({
                    projectCode: this.projectCode,
                    pageNum: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize
                })
                if (response && response.code === 200) {
                    const data = response.data || {}
                    const records = data.records || []
                    this.tableData = records.map((item, index) => ({
                        ...item,
                        no: (this.pagination.currentPage - 1) * this.pagination.pageSize + index + 1
                    }))
                    this.pagination.total = data.total || 0
                } else {
                    this.tableData = []
                    this.pagination.total = 0
                }
            } catch (error) {
                console.error('获取中标公告列表失败:', error)
                this.tableData = []
                this.pagination.total = 0
            } finally {
                this.loading = false
            }
        },
        // 获取项目信息
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },
        //返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        //查看详情
        handleViewDetails(row) {
            this.detailRow = {
                bidSectionName: row.bidSectionName || '',
                winBulletinContent: ''
            }
            this.detailDialogVisible = true
            this.loadBulletinDetail(row.winBulletinCode)
        },
        async loadBulletinDetail(winBulletinCode) {
            if (!winBulletinCode) {
                this.detailRow.winBulletinContent = ''
                return
            }
            this.detailLoading = true
            try {
                const res = await winBulletinDetail({ winBulletinCode })
                if (res && res.code === 200 && res.data) {
                    const detailData = res.data
                    this.detailRow.bidSectionName = detailData.bidSectionName || this.detailRow.bidSectionName
                    this.detailRow.winBulletinContent = sanitizeHtml(detailData.winBulletinContent || '')
                } else {
                    this.detailRow.winBulletinContent = ''
                    this.$message.error(res?.msg || '获取公告详情失败')
                }
            } catch (error) {
                console.error('获取中标公告详情失败:', error)
                this.detailRow.winBulletinContent = ''
                this.$message.error('获取公告详情失败')
            } finally {
                this.detailLoading = false
            }
        },
        handleCloseDetailDialog() {
            this.detailDialogVisible = false
            this.detailRow = {
                bidSectionName: '',
                winBulletinContent: ''
            }
        },
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.pagination.currentPage = 1
            this.getBulletinList()
        },

        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.getBulletinList()
        },

        getStatusText(status) {
            const statusMap = {
                0: '暂存',
                1: '提交',
                9: '发布'
            }
            return statusMap[status] || '未知'
        },

        getStatusType(status) {
            const statusMap = {
                0: 'info',
                1: 'warning',
                9: 'success'
            }
            return statusMap[status] || 'info'
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-child-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.page-header-content {
    display: flex;
    flex-direction: column;
    text-align: start;
}

.header-action {
    text-align: end;
    flex-shrink: 0;
}

.page-title {
    color: @gray-700;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
}

.content-container {
    padding: 20px;
    border-radius: 8px;
    box-shadow: @shadow-sm;
    background: #fff;
    text-align: start;
}

.data-table {
    border-radius: 4px;
    overflow: hidden;

    /deep/ th {
        background: @gray-50 !important;
        color: @gray-700 !important;
        font-weight: 600;
        border-color: @gray-200 !important;
    }

    /deep/ td {
        color: @gray-600;
        border-color: @gray-200 !important;
    }
}

.pagination-section {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}

.action-btn {
    color: @gray-600;
    margin-right: 10px;
}

.action-btn:hover {
    color: @primary-color;
}

@media (max-width: 768px) {
    .bidder-child-page {
        padding: 16px;
    }

    .page-header {
        flex-direction: column;
        align-items: stretch;
    }

    .header-action {
        text-align: left;
    }

    .page-title {
        font-size: 20px;
    }

    .content-container {
        padding: 16px;
    }
}


.price-text {
    font-weight: bold;
    color: #e6a23c;
}

/* 公告详情弹窗样式 */
.check-notice-detail-dialog {
    /deep/ .el-dialog__body {
        padding: 20px 24px;
    }
}

.detail-view {
    text-align: start;
}

.detail-item {
    display: flex;
    align-items: flex-start;
    padding: 12px 0;
    border-bottom: 1px dashed @gray-200;
    font-size: 14px;
    line-height: 1.6;
}

.detail-item:last-child {
    border-bottom: none;
}

.detail-item label {
    flex-shrink: 0;
    width: 90px;
    color: @gray-500;
    margin-right: 12px;
}

.detail-item span {
    flex: 1;
    color: @gray-700;
    word-break: break-all;
}

.detail-item--block {
    flex-direction: column;
    align-items: stretch;
}

.detail-item--block label {
    width: auto;
    margin-bottom: 8px;
}

.detail-content {
    font-size: 14px;
    line-height: 1.8;
    color: #333;
    word-break: break-all;

    :deep(h2), :deep(h3), :deep(h4) {
        margin: 20px 0 12px;
        color: #333;
    }

    :deep(h3) {
        font-size: 18px;
    }

    :deep(h4) {
        font-size: 16px;
    }

    :deep(p) {
        margin: 12px 0;
    }

    :deep(ul), :deep(ol) {
        padding-left: 24px;
        margin: 12px 0;
    }

    :deep(li) {
        margin: 8px 0;
    }

    :deep(hr) {
        border: none;
        border-top: 1px solid #eee;
        margin: 20px 0;
    }

    :deep(img) {
        max-width: 100%;
        height: auto;
    }

    :deep(table) {
        border-collapse: collapse;
        border: 1px solid #ddd;
        margin: 16px 0;
        font-size: 14px;
        width: auto !important;
    }

    :deep(table td),
    :deep(table th) {
        border: 1px solid #ddd;
        padding: 6px 10px;
        vertical-align: middle;
    }

    :deep(table th) {
        background: #f5f5f5;
        font-weight: 600;
        text-align: center;
    }
}

.detail-empty {
    color: @gray-400;
    font-size: 13px;
    padding: 16px;
    background: @gray-50;
    border-radius: 4px;
    text-align: center;
}

.dialog-footer {
    text-align: right;
}
</style>
